import classNames from 'classnames';
import React from 'react';
import VehicleMaintenanceContracts from '../../maintenance/components/VehicleMaintenanceContracts';
import css from './PackServiceInclusive.scss';

interface PackServiceInclusiveContainerProps {
    licensePlate: string;
    vin: string;
    vehcode: number;
}

const PackServiceInclusive: React.FC<PackServiceInclusiveContainerProps> = (Props) => {
    return (
        <React.Fragment>
            <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw-pacotes', 'service-inclusive'])}>
                <div className={css.width100}>
                    <div className={classNames(['grid-container', 'fluid', 'padding-left-0'])}>
                        <VehicleMaintenanceContracts vehcode={Props.vehcode} vin={Props.vin} licensePlate={Props.licensePlate} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PackServiceInclusive;
